export const structureFolderTree = (
  activeFolder,
  { folder_name, name = folder_name, id, key = id, folders }
) => ({
  id,
  folder_name,
  name,
  key,
  active: activeFolder.id === id,
  toggled: activeFolder.id === id,
  ...(folders && {
    children: folders.map(folder => structureFolderTree(activeFolder, folder)),
  }),
});
